import store from '@/core/store'
import { addNewContactLabel, editContactLabel, removeContactLabel, switchCurrentActiveLabelFilter } from '@/core/store/Slices/ContactsLabelsSlice'
import contactsService from '../contacts/contacts.service'
import { createContactLabel, deleteContactLabel, editExistingContactLabel, getContactsLabels, setLabelsForContact } from './contactslabels.api'

class ContactsLabelsService {
  async getAllContactLabels () {
    const allContactLabels = await getContactsLabels()
    const allContactLabelsArray = Object.values(allContactLabels)
    allContactLabelsArray.forEach((contactlabel) => {
      store.dispatch(addNewContactLabel(contactlabel))
    })
    store.commit('CONTACTLABEL_LIST:UPDATED', allContactLabelsArray)

    return allContactLabelsArray
  }

  getAllStoredContactLabels () {
    return store.getState().contactlabels.contactslabels
  }

  getContactLabelsNumber () {
    const contactlabels = this.getAllStoredContactLabels()
    return Object.values(contactlabels).length
  }

  async addContactLabel (newContactLabel) {
    const contactlabel = await createContactLabel(newContactLabel)
    store.dispatch(addNewContactLabel(contactlabel))
    store.commit('CONTACTLABEL_LIST:UPDATED', Object.values(this.getAllStoredContactLabels()))
    store.commit('CONTACTLABEL_LIST:FOCUS', contactlabel)
    return contactlabel
  }

  async editContactLabel (contactLabel, changedProperties) {
    const updatedContactLabel = {
      ...contactLabel,
      ...changedProperties
    }

    store.dispatch(editContactLabel(updatedContactLabel))
    const updatedLabelFromAPI = await editExistingContactLabel(updatedContactLabel)
    this.updateContactsForLabel(contactLabel, updatedLabelFromAPI)

    store.commit('CONTACTLABEL_LIST:UPDATED', Object.values(this.getAllStoredContactLabels()))
    return updatedContactLabel
  }

  async removeContactLabel (contactlabel) {
    const contactlabelToDelete = Object.values(store.getState().contactlabels.contactslabels).filter((_contactlabel) => _contactlabel.id === contactlabel.id)[0]
    store.dispatch(removeContactLabel(contactlabelToDelete))
    await deleteContactLabel(contactlabelToDelete)
    store.commit('CONTACTLABEL_LIST:UPDATED', Object.values(this.getAllStoredContactLabels()))
  }

  switchToContactsBelongingToLabel (label) {
    const filter = {
      type: label.id ? 'label' : 'group',
      value: label.composedid || label,
      name: label.name || label
    }
    store.dispatch(switchCurrentActiveLabelFilter(filter))
    store.commit('CONTACT_LIST:FILTER_UPDATED', { filter, contacts: contactsService.getContactsForFilter(filter) })
  }

  getCurrentLabelFilter () {
    return store.getState().contactslabels.currentActiveLabelFilter
  }

  findLabelsForContact (contact) {
    const _contact = contactsService.getContactByContactEntity(contact)
    return _contact.contactlabels
  }

  updateContactsForLabel (label, updatedLabel) {
    const _contacts = contactsService.getContactsForLabel(label)
    const updatedContacts = _contacts.map((contact) => {
      contact = JSON.parse(JSON.stringify(contact)) // Avoiding read-only issues
      const labelMatchIndex = contact.contactlabels?.findIndex(cLabel => cLabel.composedid === label.composedid)
      if (labelMatchIndex !== -1) {
        contact.contactlabels[labelMatchIndex] = updatedLabel
      }
      return contact
    })
    contactsService.updateStoredContacts(updatedContacts)
    this.switchToContactsBelongingToLabel(updatedLabel)
  }

  async attachLabelsToContact (contact, labels) {
    const parsedLabelIds = labels.map(label => label.composedid)
    const _contact = await setLabelsForContact(contact, parsedLabelIds)
    // FIXME: We should add this inside ContactsService, no ContactsLabels one.
    contactsService.editContact(_contact, true)
    store.commit('CONTACT_LIST:UPDATED', contactsService.getContactsForCurrentFilter())
    store.commit('CONTACTLABEL_LIST:UPDATED', Object.values(this.getAllStoredContactLabels()))
    store.commit('CONTACT_VIEW:UPDATED', _contact)
    return _contact
  }
}

export default new ContactsLabelsService()
